import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 90 90"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m85.542 41.023-5.625-5.625a5.626 5.626 0 0 0-7.326-.538L55.139 17.408a5.625 5.625 0 0 0-.534-7.326L48.98 4.457a5.625 5.625 0 0 0-7.956 0l-22.5 22.5a5.625 5.625 0 0 0 0 7.955l5.625 5.625a5.625 5.625 0 0 0 7.323.535l2.52 2.52-22.985 22.986a8.79 8.79 0 0 0 12.418 12.417L46.406 56.01l2.521 2.517a5.624 5.624 0 0 0 .534 7.326l5.625 5.625a5.624 5.624 0 0 0 7.956 0l22.5-22.5a5.626 5.626 0 0 0 0-7.955M28.125 36.56 22.5 30.936 45 8.436l5.625 5.625zm-8.676 38.454a3.164 3.164 0 0 1-4.462 0 3.164 3.164 0 0 1 0-4.458L37.97 47.572l4.461 4.458zm16.059-37.87 15.7-15.7L68.556 38.79l-15.698 15.7zm23.554 30.354-5.624-5.625 1.406-1.407L74.53 40.78l1.406-1.406 5.626 5.625z"
    }, null, -1)
  ])))
}
export default { render: render }